import { createSelector } from "@reduxjs/toolkit";
import * as Immutable from "immutable";
export const selectSearchMetadataState = (state) => state.searchMetadata;
export const selectSearchMetadata = createSelector(selectSearchMetadataState, (state) => state.metadata);
export const selectUndeclaredParameters = createSelector(
  selectSearchMetadata,
  (searchMetadata) => {
    var _a;
    return (_a = searchMetadata == null ? void 0 : searchMetadata.undeclared) != null ? _a : Immutable.Set();
  }
);
export const selectHasUndeclaredParameters = createSelector(
  selectUndeclaredParameters,
  (undeclared) => (undeclared == null ? void 0 : undeclared.size) > 0
);
